class TouchstartDirective {
    constructor() {
        this.restrict = 'A';
    }

    link(scope, element, attrs) {
        element.on('touchstart', function(event) {
            scope.$event = event;
            scope.$apply(function() {
                scope.$eval(attrs.touchstart);
            });
        });
        element.on('mousedown', function(event) {
            scope.$event = event;
            scope.$apply(function() {
                scope.$eval(attrs.touchstart);
            });
        });
    }

    static directiveFactory() {
        'ngInject';
        return new TouchstartDirective();
    }
}

export default TouchstartDirective;
